import React from "react";
import type {VoidFunctionComponent} from "react";
import InfoModal from "../../../../components/common/InfoModal";
import settingsService from "../../../../services/settings/settingsService";

export interface ISongsInfoModalProps {
  onCloseHandler: () => void;
  isModalVisible: boolean;
}

export const SongsInfoModal: VoidFunctionComponent<ISongsInfoModalProps> = ({onCloseHandler, isModalVisible}) => {
  if (!isModalVisible) {
    return null;
  }

  if (!settingsService.hasSongModalBeenDisplayed()) {
    settingsService.hasSongModalBeenDisplayed(true);
  }

  return (
    <InfoModal
      onClose={onCloseHandler}
      title={"About Songs"}
      icon={"icon-songs"}
      text={"See what's new and notable, browse the entire song collection, add arrangements to your library, and play them as much as you like!"}
    />
  );
}

